// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

// App Configuration - APP_NAME now comes from AppInfoContext
export const APP_VERSION = '2.0.0';

// File Upload Configuration
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'text/plain',
  'text/markdown',
];

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  THEME_MODE: 'chakra-ui-color-mode',
  SETTINGS: 'compassai-settings',
  DRAFTS: 'compassai-drafts',
} as const;

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  PASSWORD_RESET: '/auth/password-reset',
  SETTINGS: '/settings',
  SHARED: '/shared',
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    VERIFY: '/api/auth/verify',
    RESET_PASSWORD: '/api/auth/reset-password',
    CHANGE_PASSWORD: '/api/auth/change-password',
  },
  CONFIG: {
    GET: '/api/config',
    UPDATE: '/api/config',
  },
  DOCUMENTS: {
    UPLOAD: '/api/documents/upload',
    PROCESS: '/api/documents/process',
    DOWNLOAD: '/api/documents/download',
    SHARE: '/api/documents/share',
  },
  SETTINGS: {
    GET: '/api/settings',
    UPDATE: '/api/settings',
  },
} as const;